import { render, staticRenderFns } from "./SimpleSearch.vue?vue&type=template&id=7260f1c2"
import script from "./SimpleSearch.vue?vue&type=script&lang=js"
export * from "./SimpleSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports